<template>
  <v-btn icon flat small @click="goExpediente">
    <v-tooltip bottom>
      <v-icon slot="activator" color="primary">keyboard_arrow_right</v-icon>
      <span>Ver expediente</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    goExpediente () {
      this.$router.push({ name: 'detalleExpediente', params: { id: this.item.id } })
    }
  }
}
</script>
